import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WebsiteComponent } from './website.component';
import { HomePageComponent } from './home-page/home-page.component';
import { ContactComponent } from './contact/contact.component';
import { DocumentsComponent } from './documents/documents.component';
import { FaqComponent } from './faq/faq.component';
import { GlossaryComponent } from './glossary/glossary.component';
import { EsriMapsComponent } from 'src/app/shared/esri-maps/esri-maps.component';

import { Routes, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { GlossaryResolver } from 'src/app/Resolvers/admin/glossaries-data-resolver';
import { DOCsResolver } from 'src/app/Resolvers/admin/documents-data-resolver';
import { FAQResolver } from 'src/app/Resolvers/admin/faq-data-resolver';
import { BudgetCenterComponent } from './budget-center/budget-center.component';
import { BCenterResolver } from 'src/app/Resolvers/website/budget-center-data-resolver';
import { KpiComponent } from './kpi/kpi.component';
import { ActiveGlossaryResolver } from 'src/app/Resolvers/website/active-glossary-data-resolver';
import { ActiveFAQResolver } from 'src/app/Resolvers/website/active-faqs-data-resolver';
import { KPIStatusResolver } from 'src/app/Resolvers/website/kpi-statuses-data-resolver';
import { ActiveKPISResolver } from 'src/app/Resolvers/admin/active-kpis-data.resolver';
import { MyKpisResolver } from 'src/app/Resolvers/website/my-kpi-data-resolver';
import { ManageReportingComponent } from '../admin/manage-reporting/manage-reporting.component';
import { BcFocusComponent } from './bc-focus/bc-focus.component';
import { BCFocusResolver } from 'src/app/Resolvers/website/bc-focus-data-resolver';

import {ReportsComponent} from './reports/reports.component'
import {ReportsResolver} from 'src/app/Resolvers/website/reports-data-resolver'

import { AuthGuard } from 'src/app/Guards/auth.guard';
//import { BasicFilterPipe } from '../../Pipes/basic-filter.pipe';
import { ActiveKPISListResolver } from 'src/app/Resolvers/admin/active-kpis-list-data.resolver';
import { ValidationTrackerComponent } from './validation-tracker/validation-tracker.component';
import { SharedModule } from '../shared/shared.module';
import { ChangeRoleComponent } from './change-role/change-role.component';
import { PopoverModule } from 'ngx-smart-popover';

import { ManageRegionalReportingComponent } from '../admin/manage-regional-reporting/manage-regional-reporting.component';
import { from } from 'rxjs';
import { MyRegionalKpisResolver } from 'src/app/Resolvers/website/my-regional-kpi-data-resolver';

const approutes: Routes = [
  {
    path: '',
    component: WebsiteComponent,
    children: [
      { path: 'contact', component: ContactComponent },
      { path: 'faq', component: FaqComponent, resolve: { data: ActiveFAQResolver } },
      { path: 'documents', component: DocumentsComponent, resolve: { data: DOCsResolver }  },
      { path: 'glossary', component: GlossaryComponent, resolve: { data: ActiveGlossaryResolver } },
      { path: 'dashboard', component: HomePageComponent, resolve: { data:ActiveKPISListResolver, bcs:BCenterResolver } },
      { path: 'validation-tracker', component: ValidationTrackerComponent, resolve: { data:ActiveKPISListResolver, bcs:BCenterResolver } },
      { path: 'budget-center', component: BudgetCenterComponent, resolve: { data: BCenterResolver} },
      { path: 'reports', component: ReportsComponent, resolve: { reports: ReportsResolver,bcs: BCenterResolver,kpis: ActiveKPISResolver} },
      { path: 'kpi', component: KpiComponent, resolve: { data: ActiveKPISListResolver, status: KPIStatusResolver} },
      { path: 'bc-focus/:bcid/:kpiId/:year/:quarter', component: BcFocusComponent, resolve: { data: BCFocusResolver, status: KPIStatusResolver} },
      { path: 'manage-reporting', component: ManageReportingComponent, resolve: {data: MyKpisResolver}, canActivate: [AuthGuard] },
      { path: 'manage-reporting/:bcid/:kpiId/:year/:quarter', component: ManageReportingComponent, resolve: {data: MyKpisResolver}, canActivate: [AuthGuard] },
      { path: 'manage-regional-reporting', component: ManageRegionalReportingComponent, resolve: {data: MyRegionalKpisResolver}, canActivate: [AuthGuard] },
      { path: 'manage-regional-reporting/:kpiId/:year/:quarter', component: ManageRegionalReportingComponent, resolve: {data: MyRegionalKpisResolver}, canActivate: [AuthGuard] },
      { path: 'change-role/:id', component: ChangeRoleComponent, canActivate: [AuthGuard] },
    ]
  }
]

@NgModule({
  declarations: [WebsiteComponent, HomePageComponent, ContactComponent, DocumentsComponent, FaqComponent, GlossaryComponent, BudgetCenterComponent, KpiComponent,
    EsriMapsComponent, ManageReportingComponent, ManageRegionalReportingComponent, BcFocusComponent, ValidationTrackerComponent, ChangeRoleComponent],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule.forChild(approutes),
    SharedModule,
    PopoverModule
  ],
})
export class WebsiteModule { }
